import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-medium",
  "use": "icon-medium-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-medium\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#000\" /><circle cx=\"7\" cy=\"12\" r=\"4\" fill=\"#fff\" /><ellipse cx=\"14.5\" cy=\"12\" fill=\"#fff\" rx=\"2.5\" ry=\"4\" /><ellipse cx=\"19\" cy=\"12\" fill=\"#fff\" rx=\"1\" ry=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol